import { css } from "@emotion/css";
import { Card, Col, Row } from "antd";
import React, { useEffect, useRef } from "react";

function AdminSignupRCol({ children, styled, isPurple }) {
  const target = useRef(null);

  function handleMouseMove(event) {
    if (target.current) {
      const height = window.innerHeight;
      const width = window.innerWidth;
      // Creates angles of (-20, -20) (left, bottom) and (20, 20) (right, top)
      const yAxisDegree = (event.pageX / width) * 20 - 10;
      const xAxisDegree = (event.pageY / height) * -1 * 20 + 10;

      target.current.style.transform = `rotateY(${yAxisDegree}deg) rotateX(${xAxisDegree}deg)`;
      // Set the sheen position
      setSheenPosition(event.pageX / width, event.pageY / width);
    }
  }

  function setSheenPosition(xRatio, yRatio) {
    if (target.current) {
      // This creates a "distance" up to 200px each direction to offset the sheen
      const xOffset = 1 - (xRatio - 0.5) * 50;
      const yOffset = 1 - (yRatio - 0.5) * 5;
      target.current.style.setProperty("--screenX", `${xOffset}px`);
      target.current.style.setProperty("--screenY", ` ${yOffset}px`);
    }
  }

  useEffect(() => {
    if (!false) {
      document.onmousemove = handleMouseMove;
    }
  }, []);
  return (
    <div
      className={css`
        opacity: 0;

        animation: fadeIn 1s forwards;
        @keyframes fadeIn {
          from {
            opacity: 1;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes shape1 {
          from {
            left: 50px;
            top: 40px;
          }
          to {
            left: -40px;
            top: 40px;
          }
        }
        @keyframes shape2 {
          from {
            right: 60px;
            top: 24px;
          }
          to {
            right: -54px;
            top: -23px;
          }
        }
        @keyframes shape3 {
          from {
            bottom: 25px;
          }
          to {
            bottom: -70px;
          }
        }
        // @keyframes shapeSpin {
        //   from {
        //     transform: rotate(0deg);
        //   }
        //   to {
        //     transform: rotate(360deg);
        //   }
        // }
      `}
      style={{
        // perspective: "5500px",
        // paddingTop: "20px",
        // paddingLeft: "20px",
        position: "relative",
        margin: "60px 30px",
        marginTop: "0px",
      }}
    >
      {" "}
      <img
        src="/pics/Meet max shape1.png"
        alt="Shape 1"
        style={{
          width: "140px",
          position: "absolute",
          top: "25%",
          left: "100px",
          opacity: 1,
          animation: "shape1 1s forwards, shapeSpin 5s linear infinite",
          animationDelay: "1s",
        }}
      />
      <img
        src="/pics/Meet max shape2.png"
        alt="Shape 2"
        style={{
          width: "160px",
          position: "absolute",
          top: "25%",
          right: "100px",
          opacity: 1,
          animation: "shape2 1s forwards, shapeSpin 5s linear infinite",
          animationDelay: "1s",
        }}
      />
      <img
        src="/pics/Meet max shape3.png"
        alt="Shape 3"
        style={{
          width: "160px",
          position: "absolute",
          left: "50%",
          bottom: "25px",
          opacity: 1,
          animation: "shape3 1s forwards, shapeSpin 5s linear infinite",
          animationDelay: "1s",
        }}
      />
      {isPurple ? (
        <Card
          ref={target}
          className={css`
            background-color: white;
            box-shadow: 0px 0px 12px 4px rgba(0, 0, 0, 0.1);
          `}
          style={styled}
        >
          {children}
        </Card>
      ) : (
        <Card
          ref={target}
          className={css`
            box-shadow: 0px 0px 12px 4px rgba(0, 0, 0, 0.1);
          `}
          style={styled}
        >
          {children}
        </Card>
      )}
    </div>
  );
}

export default AdminSignupRCol;
